// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { calendarWeek16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-calendar-week': IconCalendarWeek;
    }
}

/**
 * The icon component for the 'calendarWeek' icon
 */
export class IconCalendarWeek extends Icon {
    public constructor() {
        super(calendarWeek16X16);
    }
}

registerIcon('icon-calendar-week', IconCalendarWeek);
export const iconCalendarWeekTag = 'nimble-icon-calendar-week';
